import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({
  fontSizes, lineHeights, breakpoints, palette,
}: Theme) => ({
  icon: {
    textAlign: 'center',
    '& svg': {
      width: 'auto',
      height: 120,
    },
  },
  title: {
    letterSpacing: 'normal',
    [breakpoints.down('sm')]: {
      width: 250,
    },
  },
  content: {
    marginBottom: 8,
    marginTop: 16,
    '& p': {
      display: 'block',
      margin: 0,
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.md,
      textAlign: 'left',
      [breakpoints.up('md')]: {
        fontSize: fontSizes.sm,
        lineHeight: lineHeights.md,
      },
    },
  },
  callButton: {
    textDecoration: 'none',
    color: palette.common.white,
  },

  footerButtons: {
    marginTop: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    [breakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: 16,
    },
  },

  phoneButtonLink: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'inline-block',
    whiteSpace: 'nowrap',
    padding: '0 16px',
    minWidth: 220,
    textAlign: 'center',
    fontWeight: 600,
  },

  confirmButton: {
    '&.outlined': {
      width: 'fit-content',
      [breakpoints.down('sm')]: {
        width: '100% !important',
      },
    },
  },
}));
